import { render, staticRenderFns } from "./VarietyInformation.vue?vue&type=template&id=49cd255c&scoped=true&"
import script from "./VarietyInformation.vue?vue&type=script&lang=js&"
export * from "./VarietyInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cd255c",
  null
  
)

export default component.exports